
import CodeSnippet from '@/components/molecules/code-snippet/code-snippet';

export default {
  name: 'TestingPropCodeExample',

  components: {
    CodeSnippet,
  },
};
